import * as React from 'react';
import NavbarLabel from './NavbarLabel';
import { getOr } from '@/utils/options';
import { ItemsList, Maybe } from 'types/generated';
import NavbarDropdownList from './NavbarDropdownList';
import clsx from 'clsx';
import OutsideClickHandler from '@/components/common/OutsideClickHandler';

type Props = {
  title: Maybe<string> | undefined;
  data: ItemsList;
  showMobileMenu?: boolean;
  isSelected: boolean;
  setOpenDropdownTitle: (title: string | null) => void;
  openDropdownTitle?: string | null;
  setOpenList?: (isOpen: boolean) => void;
  transparent?: boolean;
};

const NavbarDropdownListLabel = ({
  title,
  showMobileMenu = false,
  isSelected,
  data,
  setOpenDropdownTitle,
  openDropdownTitle,
  transparent = false,
  setOpenList,
}: Props) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
    if (showMobileMenu) {
      setOpenList && setOpenList(true);
      return;
    }
    setOpenList && setOpenList(isOpen);
    setOpenDropdownTitle(null);
  };

  React.useEffect(() => {
    if (openDropdownTitle) {
      setIsOpen(false);
    }
  }, [openDropdownTitle, title]);

  return (
    <div className={clsx({ 'self-stretch': showMobileMenu })}>
      <NavbarLabel
        onClick={handleClick}
        hasChevron={!showMobileMenu}
        title={getOr(title, '')}
        showMobileMenu={showMobileMenu}
        isSelected={isSelected}
        transparent={transparent}
      />
      {!showMobileMenu && (
        <OutsideClickHandler
          onClick={() => {
            setIsOpen(false);
          }}
        >
          <NavbarDropdownList
            isOpen={isOpen}
            data={data}
            setOpenDropdownTitle={setOpenDropdownTitle}
            setOpenList={setOpenList}
            openDropdownTitle={openDropdownTitle}
            showMobileMenu={showMobileMenu}
          />
        </OutsideClickHandler>
      )}
    </div>
  );
};

export default NavbarDropdownListLabel;
